/**
 * Caminho URL do painel super-admin (sem ligação na UI pública).
 * Defina VITE_PLATFORM_ENTRY_PATH no .env do frontend (ex.: xK9mP2wQvL4n) para não usar o caminho previsível "platform".
 */

const RESERVED = new Set([
  'admin',
  'cadastro',
  'e',
  'profissional',
  'menu',
  'perfil',
  'pacotes',
  'agendamento',
  'historico',
  'servicos',
  'vip',
  'quem-somos',
  'contatos',
  'mapa',
  'galeria',
  'social',
  'api',
  'uploads',
])

function normalizeSegment(raw: string): string {
  const s = String(raw || '')
    .trim()
    .replace(/^\/+|\/+$/g, '')
    .replace(/[^a-zA-Z0-9_-]/g, '')
    .slice(0, 64)
  if (!s) return 'platform'
  const lower = s.toLowerCase()
  if (RESERVED.has(lower)) return `${s}-ops`
  return s
}

/** Segmento único para React Router (sem barra inicial). */
export function platformRouteSegment(): string {
  const fromEnv = import.meta.env.VITE_PLATFORM_ENTRY_PATH
  if (fromEnv != null && String(fromEnv).trim() !== '') {
    return normalizeSegment(String(fromEnv))
  }
  return 'platform'
}

/** Caminho base com barra inicial, ex.: /platform ou /xK9mP2wQvL4n */
export function getPlatformBasePath(): string {
  return `/${platformRouteSegment()}`
}

export function getPlatformLoginPath(): string {
  return `${getPlatformBasePath()}/login`
}

export function getPlatformDashboardPath(): string {
  return `${getPlatformBasePath()}/dashboard`
}

export function getPlatformTenantsPath(): string {
  return `${getPlatformBasePath()}/tenants`
}

export function getPlatformNovaTenantPath(): string {
  return `${getPlatformBasePath()}/tenants/novo`
}

export function getPlatformTenantDetailPath(tenantId: number): string {
  return `${getPlatformBasePath()}/tenants/${tenantId}`
}

/** Rotas do painel super-admin (não carregar tema_app do salão). */
export function isPlatformPath(pathname: string): boolean {
  const base = getPlatformBasePath()
  return pathname === base || pathname.startsWith(`${base}/`)
}

/** Classe global usada em platformTheme.css (não é CSS module). */
export const PLATFORM_ROOT_CLASS = 'platformRoot'
